/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Duration_DaysInputs */

const en_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (Days)`)
};

const es_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración (Días)`)
};

const fr_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée (Jours)`)
};

const de_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer (Tage)`)
};

const ja_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日数`)
};

const zh_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`持续天数`)
};

const ar_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدة (بالأيام)`)
};

const id_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durasi (Hari)`)
};

const it_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata (Giorni)`)
};

const ru_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длительность (Дней)`)
};

const pt_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração (Dias)`)
};

const ko_field_duration_days = /** @type {(inputs: Field_Duration_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기간 (일수)`)
};

/**
* | output |
* | --- |
* | "Duration (Days)" |
*
* @param {Field_Duration_DaysInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_duration_days = /** @type {((inputs?: Field_Duration_DaysInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Duration_DaysInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_duration_days(inputs)
	if (locale === "es") return es_field_duration_days(inputs)
	if (locale === "fr") return fr_field_duration_days(inputs)
	if (locale === "de") return de_field_duration_days(inputs)
	if (locale === "ja") return ja_field_duration_days(inputs)
	if (locale === "zh") return zh_field_duration_days(inputs)
	if (locale === "ar") return ar_field_duration_days(inputs)
	if (locale === "id") return id_field_duration_days(inputs)
	if (locale === "it") return it_field_duration_days(inputs)
	if (locale === "ru") return ru_field_duration_days(inputs)
	if (locale === "pt") return pt_field_duration_days(inputs)
	return ko_field_duration_days(inputs)
});